import { useSelector } from 'react-redux'
import { isAfter, addMinutes, parseISO } from 'date-fns'
import { pathOr } from 'ramda'
import { MY_ACCOUNT } from '../constants'
import { getAccountIdFromState } from '../selectors/session'

/**
 * Custom hook to check if the user's account password is still valid.
 *
 * Retrieves the user's last password confirmation timestamp from the Redux store
 * and determines whether it has expired based on a predefined validation interval.
 *
 * @returns {boolean} - `true` if the password is still valid (within the allowed interval),
 *                      `false` if it has expired or was never confirmed.
 */
export const usePasswordValidation = () => {
  const accountId = useSelector(getAccountIdFromState)
  const passwordTimestamp = useSelector(state => pathOr(null, ['accounts', accountId, 'passwordTimestamp'], state))

  if (!passwordTimestamp) return false

  const expiryTime = addMinutes(parseISO(passwordTimestamp), MY_ACCOUNT.PASSWORD_VALIDATION_INTERVAL)
  return !isAfter(new Date(), expiryTime) // returns true if password is still valid
}
